import type { TRuleWithTheme } from '@/styles/theme';

export const button: TRuleWithTheme = () => ({
    marginTop: '2.5rem',

    min768: {
        marginTop: '3rem',
    },
});
